module.exports = __webpack_public_path__ + "static/our-philosophy-04cc8d6d3be55648cb0818906db4dba0.svg";